/*
 * Copyright (c) 2022. Nedaware SL
 */

import {WidgetType} from "./widget";
import {TestWidget2Component} from "./test-widget2/test-widget2.component";
import {PiezasProduccionWidgetComponent} from "./piezas-produccion-widget/piezas-produccion-widget.component";
import {
    SolicitudesPendientesValidarWidgetComponent
} from "./solicitudes-pendientes-validar-widget/solicitudes-pendientes-validar-widget.component";
import {
    SolicitudesValidadasWidgetComponent
} from "./solicitudes-validadas-widget/solicitudes-validadas-widget.component";
import {UltimasFacturasWidgetComponent} from "./ultimas-facturas/ultimas-facturas-widget.component";
import {PiezasEnTransitoWidgetComponent} from "./piezas-en-transito-widget/piezas-en-transito-widget.component";
import {
    SolicitudesRechazadasWidgetComponent
} from "./solicitudes-rechazadas-widget/solicitudes-rechazadas-widget.component";
import {IncidenciasWidgetComponent} from "./incidencias-widget/incidencias-widget.component";
import {PedidosRechazadosWidgetComponent} from "./pedidos-rechazados-widget/pedidos-rechazados-widget.component";
import {
    SolicitudesIntraoralesPendientesValidarWidgetComponent
} from "./solicitudes-intraorales-pendientes-validar-widget/solicitudes-intraorales-pendientes-validar-widget.component";
import {
    SolicitudesIntraoralesValidadasWidgetComponent
} from "./solicitudes-intraorales-validadas-widget/solicitudes-intraorales-validadas-widget.component";
import {
    SolicitudesIntraoralesRechazadasWidgetComponent
} from "./solicitudes-intraorales-rechazadas-widget/solicitudes-intraorales-rechazadas-widget.component";


/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export const AVAILABLE_WIDGETS: WidgetType[] = [
    // TestWidget2Component,
    PiezasProduccionWidgetComponent,
    SolicitudesPendientesValidarWidgetComponent,
    SolicitudesValidadasWidgetComponent,
    PiezasEnTransitoWidgetComponent,
    PedidosRechazadosWidgetComponent,
    SolicitudesRechazadasWidgetComponent,
    IncidenciasWidgetComponent,
    UltimasFacturasWidgetComponent,
    SolicitudesIntraoralesPendientesValidarWidgetComponent,
    SolicitudesIntraoralesValidadasWidgetComponent,
    SolicitudesIntraoralesRechazadasWidgetComponent
];
